// eslint-ignore
export default 
`<DtTabs :tabList="tabs">
  <template v-slot:tabPanel-1> Content 1 </template>
  <template v-slot:tabPanel-2> Content 2 </template>
  <template v-slot:tabPanel-3> Content 3 </template>
  <template v-slot:tabPanel-4> Content 4 </template>
</DtTabs>

export default {
  data () {
    return {
      tabs: [
          { text: 'Tab 1'},
          { text: 'Tab 2'},
          { text: 'Tab 3'},
          { text: 'Tab 4'}
      ]
    }
  }
}`;